// extracted by mini-css-extract-plugin
export var quantityInput = "_g5-0";